<ion-header class="extendido">
  <ion-buttons left>
    <ion-button (click)="closeModal()">
      <ion-back-button
        icon="arrow-back-outline"
        text=""
        defaultHref="login"
      ></ion-back-button>
    </ion-button>
    <ion-title>{{'Recuperar Senha' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content padding>
  <div class="gradient-extendido"></div>

  <ion-card class="gradient-extendido-recuo margin-card" *ngIf="!formEnviado">
    <ion-card-content>
      <form
        class="sample-form validations-form"
        [formGroup]="validations_form"
        (ngSubmit)="onSubmit(validations_form.value)"
      >
        <div class="dangerEmail">
          <i class="fa-solid fa-envelope icon-enve"></i>

          <ion-label>{{'Informe seu e-mail cadastrado' | translate}}</ion-label>
        </div>

        <ion-row class="ion-aling">
          <ion-col size="12">
            <ion-item class="transparente-new">
              <ion-input
                type="email"
                class="custom"
                formControlName="email"
                placeholder="{{'Ex: email@email.com' | translate}}"
              ></ion-input>
            </ion-item>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col offset="1" size="10">
            <div class="validation-errors">
              <ng-container
                *ngFor="let validation of validation_messages.email"
              >
                <div
                  class="error-message"
                  *ngIf="validations_form.get('email')?.hasError('email') && validations_form.get('email')?.touched && validations_form.get('email')?.dirty"
                >
                  {{ validation.message }}
                </div>
              </ng-container>
            </div>
          </ion-col>
        </ion-row>

        <div class="down">
          <ion-button
            expand="block"
            color="primary"
            type="submit"
            [disabled]="!validations_form.valid"
            class="btn-prover enviar"
          >
            {{'Enviar' | translate}}
          </ion-button>
        </div>
      </form>
    </ion-card-content>
  </ion-card>

  <div *ngIf="formEnviado && error" style="margin: 0 25px">
    <p class="text-custom">{{errorMessage | translate}}</p>
  </div>

  <ion-footer class="ion-no-border custom-footer">
    <ion-grid>
      <ion-row *ngIf="formEnviado && !error" class="ion-justify-content-center">
        <ion-col size="10">
          <p class="center-text bold-1 text-custom">
            {{'Você receberá um e-mail com informações para cadastrar uma nova
            senha!' | translate}}
          </p>

          <p class="center-text bold-1 text-custom">
            {{'Caso você não receba o e-mail, entre em contato com o responsável
            pela sua igreja para solicitar o reenvio' | translate}}
          </p>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-footer>
</ion-content>

<ion-footer class="exit footer-button">
  <ion-label (click)="closeModal()">
    <ion-icon
      slot="end"
      name="arrow-back-outline"
      class="close-modal"
    ></ion-icon>
    {{'Voltar ao início' | translate}}
  </ion-label>
</ion-footer>
